import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderZipCode,
  renderDropdown,
  renderAddDeleteButton,
  renderAdditionalComments,
  renderFile,
  renderMultiTextBox,
  renderEffectiveDate,
} from "./RenderUtils";

export class AdditionalInsuredRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <Form ref={this.props.formRef}>
        <div>
          {renderEffectiveDate(request, updateRequest)}
          {renderMultiTextBox(
            "nameOfAdditionalInsured",
            "Name of Additional Insured",
            request,
            updateRequest
          )}
          <label className="quote-change-label">ADDITIONAL OPTIONS</label>
          {renderMultiTextBox(
            "streetAddress",
            "Street Address",
            request,
            updateRequest
          )}
          {renderTextBox(
            "city",
            "City",
            request,
            updateRequest,
            "E.g. Placeholder text"
          )}
          {renderDropdown(
            "state",
            "State",
            request,
            updateRequest,
            this.props.states
          )}
          {renderZipCode(
            "zipCode",
            "Zip Code",
            request,
            (zipCodePropertyName, zipCodePropertyValue) =>
              this.props.updateAddress(
                zipCodePropertyName,
                zipCodePropertyValue,
                "state",
                "city"
              )
          )}
          {renderTextBox(
            "relationshipToInsured",
            "Relationship to Insured",
            request,
            updateRequest
          )}
          {renderAddDeleteButton(
            "Add Additional Insured / Delete Additional Insured",
            request,
            updateRequest
          )}
          {renderAdditionalComments(updateRequest)}
          {renderFile(request, updateRequest)}
        </div>
      </Form>
    );
  }
}
